if (!customElements.get('cbm-hoppy-slot')) {
  customElements.define('cbm-hoppy-slot', class extends HTMLElement {
    connectedCallback() {
      const drawer = this.closest('#Cart-Drawer');
      if (!drawer) return;
      const placeWidget = () => {
        const widget = drawer.querySelector('#shipping-container-cart_drawer');
        if (this.isConnected && widget && widget.parentElement !== this) {
          this.appendChild(widget);
        }
      };
      this.observer?.disconnect();
      this.observer = new MutationObserver(placeWidget);
      this.observer.observe(drawer, { childList: true, subtree: true });
      placeWidget();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}

// On the cart page, both apps create one widget for the page, not the drawer.
// Move those same nodes with the panel; preserve their listeners and app state.
(() => {
  const page = document.getElementById('Cart');
  const drawer = document.getElementById('Cart-Drawer');
  if (!page || !drawer || drawer.cbmAppPlacement) return;
  drawer.cbmAppPlacement = true;

  const widgets = [
    { selector: '.seal-widget', target: '.cart-drawer-buttons', before: true },
    { selector: '#shipping-container-cart_page_only', target: 'cbm-hoppy-slot' }
  ];

  const totalText = root => root.querySelector('.cart-total td')?.textContent.trim() || '';
  let pageTotal = totalText(page);
  const syncDrawer = (force = false) => {
    const current = totalText(page);
    const changed = current !== pageTotal;
    pageTotal = current;
    // Seel renders only the page on /cart. Refresh all native drawer rows,
    // not just the price: adding protection can change every line index.
    if ((force || changed) && totalText(drawer) !== current &&
        typeof drawer.refresh === 'function') {
      drawer.refresh();
    }
  };

  const place = (records = []) => {
    const open = drawer.classList.contains('active');
    for (const state of widgets) {
      const live = document.querySelector(state.selector);
      if (live && live !== state.widget) {
        state.home?.remove();
        state.widget = live;
        state.home = document.createComment('cart app original position');
        live.before(state.home);
      }
      const widget = state.widget;
      if (!widget) continue;
      // Retain a widget removed with a rendered section, but do not undo an
      // intentional removal of the widget itself by its app.
      if (!widget.isConnected && !records.some(record =>
        Array.from(record.removedNodes || []).some(node =>
          node !== widget && node.contains(widget)))) continue;

      if (open) {
        const target = drawer.querySelector(state.target);
        if (!target || !drawer.querySelector('.cart-drawer-buttons')) continue;
        if (state.before) {
          if (target.previousElementSibling !== widget) target.before(widget);
        } else if (widget.parentElement !== target) {
          target.appendChild(widget);
        }
      } else if (drawer.contains(widget) || !widget.isConnected) {
        if (state.home?.isConnected) {
          state.home.after(widget);
        } else if (state.before) {
          const target = page.querySelector('.proceed-to-checkout');
          if (target) {
            state.home = document.createComment('cart app original position');
            target.before(state.home, widget);
          }
        }
      }
    }
  };

  const onPanel = event => {
    if (event.detail?.panel === drawer) {
      place();
      if (event.type === 'panel:open') syncDrawer(true);
    }
  };
  document.addEventListener('panel:open', onPanel);
  document.addEventListener('panel:closed', onPanel);
  const observer = new MutationObserver(records => {
    place(records);
    syncDrawer();
  });
  observer.observe(page, { childList: true, subtree: true });
  observer.observe(drawer, { childList: true, subtree: true });
  // Hoppy's page widget is inserted above the cart, inside the breadcrumbs.
  const breadcrumbs = document.querySelector('.breadcrumbs-section');
  if (breadcrumbs) observer.observe(breadcrumbs, { childList: true, subtree: true });
  place();
})();
